import React from 'react';
import Home from './pages/Home';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Login from "./pages/Login";
import MainLayout from "./layouts/MainLayout";
import VerifyOtp from "./pages/VerifyOtp";
import About from "./pages/About";
import FjSpecial from "./pages/FjSpecial";
import Contact from "./pages/Contact";
import CategoryPosts from "./pages/CategoryPosts";
import SubCategoryPosts from "./pages/SubCategoryPosts";
import Test from "./pages/Test";  

import { LocationProvider } from "./components/LocationContext";
import AppDownloadAlert from "./components/AppDownloadAlert.jsx";
function App() {
  return (
    <div>
      <BrowserRouter>
        <LocationProvider>
           {/* Mobile-only Play Store banner */}
          <AppDownloadAlert />

        
          <Routes>
            <Route element={<MainLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/category/:id" element={<CategoryPosts />} />
                <Route path="/category/:catId/sub/:subId" element={<SubCategoryPosts />} />
                <Route path="/login" element={<Login />} />
                <Route path="/verify-otp" element={<VerifyOtp />} />
                <Route path="/about" element={<About />} />
                <Route path="/fj-special" element={<FjSpecial />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/test" element={<Test />} />
            </Route>
          </Routes>
        </LocationProvider>
      </BrowserRouter>
    </div>
  ) 
}  


export default App;
